const STANDARD_SUBSCRIPTION_FARE = 'PUB_STD_SUB';
const PLUS_SUBSCRIPTION_FARE = 'PUB_PLUS_SUB';
const PREMIER_SUBSCRIPTION_FARE = 'PUB_PREMIER_SUB';
const SUBSCRIPTION_FARE_CODES = [STANDARD_SUBSCRIPTION_FARE, PLUS_SUBSCRIPTION_FARE, PREMIER_SUBSCRIPTION_FARE];

export const nonCancelledProducts = ({ booking = {} }) => [
  ...(booking.outbound?.filter(({ cancelled }) => !cancelled)?.flatMap(({ products }) => products.filter(({ cancelled }) => !cancelled)) ||
    []),
  ...(booking.inbound?.filter(({ cancelled }) => !cancelled)?.flatMap(({ products }) => products.filter(({ cancelled }) => !cancelled)) ||
    [])
];

export const productContainSubscriptionFare = ({ products = [] }) => products.some(({ code }) => SUBSCRIPTION_FARE_CODES.includes(code));
